import axios from 'axios';
import {
  FETCH_COST_OBJS_SUCCESS,
  FETCHING_COST_OBJS,
  CREATING_COST_OBJ,
  CREATE_COST_OBJ_SUCCESS,
  FETCHING_LOCATION_TYPES,
  FETCH_LOCATION_TYPES_SUCCESS,
  FETCHING_COST_OBJ_BY_ALLOCATION_UNIT_ID,
  FETCH_COST_OBJ_BY_ALLOCATION_UNIT_ID_SUCCESS,
  FETCH_ALL_COST_OBJECTS,
  FETCHING_ALL_COST_OBJECTS,
  SELECT_COST_OBJECT,
  CLEAR_COST_OBJECTS,
  FETCHING_COST_OBJ,
  FETCH_COST_OBJ_SUCCESS,
  DELETE_COST_OBJ_FAILED,
  RESET_DELETE_FAILED
} from './CostObjsConstants';

const filterEmptyAllocationUnits = costObj => {
  const validCostObj = {
    ...costObj,
    locationDtoList: [...costObj.locationDtoList],
    allocationUnitDtos: [
      ...costObj.allocationUnitDtos.filter(
        allocationUnit => allocationUnit.id !== 0
      )
    ]
  };
  return validCostObj;
};

const fetchCostObjsSuccess = (costObjs, pageState) => ({
  type: FETCH_COST_OBJS_SUCCESS,
  costObjs,
  pageState
});

const fetchingCostObj = () => ({ type: FETCHING_COST_OBJ });
const fetchCostObjSuccess = costObj => ({
  type: FETCH_COST_OBJ_SUCCESS,
  costObj
});
const fetchingCostObjs = pageStats => ({ type: FETCHING_COST_OBJS, pageStats });
const creatingCostObj = () => ({ type: CREATING_COST_OBJ });
const createCostObjSuccess = () => ({ type: CREATE_COST_OBJ_SUCCESS });
const fetchingLocationTypes = () => ({ type: FETCHING_LOCATION_TYPES });
const fetchLocationTypesSuccess = locationTypes => ({
  type: FETCH_LOCATION_TYPES_SUCCESS,
  locationTypes
});
const fetchingCostObjsByAllocationUnitId = () => ({
  type: FETCHING_COST_OBJ_BY_ALLOCATION_UNIT_ID
});
const fetchCostObjsByAllocationUnitIdSuccess = costObjs => ({
  type: FETCH_COST_OBJ_BY_ALLOCATION_UNIT_ID_SUCCESS,
  costObjs
});
const fetchAllCostObjects = costObjs => ({
  type: FETCH_ALL_COST_OBJECTS,
  costObjs
});
const fetchingAllCostObjects = () => ({ type: FETCHING_ALL_COST_OBJECTS });
const selectedCostObject = (oldCostObject, newCostObject) => ({
  type: SELECT_COST_OBJECT,
  oldCostObject,
  newCostObject
});
const clearCostObjects = () => ({ type: CLEAR_COST_OBJECTS });
const deleteCostObjFailed = message => ({
  type: DELETE_COST_OBJ_FAILED,
  message
});
const resetDeleteFailed = () => ({ type: RESET_DELETE_FAILED });

const path = 'utm/v1/cost-objects';
const locationTypes = '/location/types';

const fetchCostObjs = (page = 0, perPage = 10) => dispatch => {
  dispatch(fetchingCostObjs({ page, perPage }));
  axios
    .get(`${path}?page=${page}&perPage=${perPage}`)
    .then(costObjsResponse => {
      if (costObjsResponse.data.error) throw costObjsResponse.data.error;
      const { items, pageState } = costObjsResponse.data.data;
      dispatch(fetchCostObjsSuccess(items, pageState));
    })
    .catch(error => {
      throw error;
    });
};

const createCostObj = (costObj, pageState) => dispatch => {
  dispatch(creatingCostObj());
  const validCostObj = filterEmptyAllocationUnits(costObj);
  axios
    .post(path, { ...validCostObj })
    .then(() => {
      const { page, perPage } = pageState;
      dispatch(createCostObjSuccess());
      dispatch(fetchCostObjs(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const fetchLocationTypes = () => dispatch => {
  dispatch(fetchingLocationTypes());
  axios
    .get(path + locationTypes)
    .then(locationTypesResponse => {
      if (locationTypesResponse.data.error)
        throw locationTypesResponse.data.error;
      dispatch(fetchLocationTypesSuccess(locationTypesResponse.data.data));
    })
    .catch(error => {
      throw error;
    });
};

const fetchCostObjsByAllocationUnitId = allocationUnitId => dispatch => {
  dispatch(fetchingCostObjsByAllocationUnitId());
  axios
    .get(`${path}/allocation-unit/${allocationUnitId}`)
    .then(costObjsResponse => {
      dispatch(
        fetchCostObjsByAllocationUnitIdSuccess(costObjsResponse.data.data)
      );
    })
    .catch(error => {
      throw error;
    });
};

const fetchAllCostObjs = () => dispatch => {
  dispatch(fetchingAllCostObjects());
  axios
    .get(`${path}/all`)
    .then(costObjsResponse => {
      dispatch(fetchAllCostObjects(costObjsResponse.data.data));
    })
    .catch(error => {
      throw error;
    });
};

const fetchCostObj = costObjId => dispatch => {
  dispatch(fetchingCostObj());
  axios
    .get(`${path}/${costObjId}`)
    .then(response => {
      dispatch(fetchCostObjSuccess(response.data.data));
    })
    .catch(error => {
      throw error;
    });
};

const updateCostObj = costObj => (dispatch, getState) => {
  dispatch(creatingCostObj());
  const validCostObj = filterEmptyAllocationUnits(costObj);
  const { page, perPage } = getState().costObjs.pageState;
  axios
    .put(`${path}`, { ...validCostObj })
    .then(() => {
      dispatch(createCostObjSuccess());
      dispatch(fetchCostObjs(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const deleteCostObj = (costObjId, page, perPage) => dispatch => {
  axios
    .delete(`${path}/${costObjId}`)
    .then(resp => {
      if (resp.data.status === 200) {
        dispatch(fetchCostObjs(page, perPage));
      } else {
        const errorMessage = resp.data.errors[0].message;
        dispatch(deleteCostObjFailed(errorMessage));
      }
    })
    .catch(error => {
      throw error;
    });
};

export {
  fetchCostObjs,
  createCostObj,
  fetchLocationTypes,
  fetchCostObjsByAllocationUnitId,
  fetchAllCostObjs,
  selectedCostObject,
  clearCostObjects,
  fetchCostObj,
  deleteCostObj,
  updateCostObj,
  resetDeleteFailed
};



// WEBPACK FOOTER //
// ./src/redux/costObjs/CostObjsActions.js